import React from 'react';

import Images from '../composant/Images';

const Link = ({data, className}) => {
    if(data.length > 0){
        return (
            data.map((val) => {
                if(val.display === true){
                    let target = '',
                        content = val.name;
                    if(val.url.startsWith('http') === true){
                        target = '_blank';
                    }
                    if(val.icon.data != null){
                        content += Images({
                            data: val.icon.data
                        })
                    }
    
                    return (
                        <a href={val.url} target={target} className={className}>
                            {content}
                        </a>
                    );
                }
                else{
                    return (<div></div>);
                }
            })
        )
    }
    else{
        if(data.display === true){
            let target = '',
                content = data.name;
            if(data.url.startsWith('http') === true){
                target = '_blank';
            }

            return (
                <a href={data.url} target={target} className={className}>
                    {content}
                    <Images data={data.icon}></Images>
                </a>
            );
        }
        else{
            return (<div></div>);
        }
    }
}

export default Link;
